/* Favoritos de Exotica.
   Se guardan en el propio navegador de la clienta (localStorage), asi que no
   necesita iniciar sesion para usarlos. La lista se llama "ex_favoritos" y
   guarda los "handle" de los productos. */
(function () {
  var CLAVE = 'ex_favoritos';

  // Registro anonimo de lo que la gente guarda, en un Formulario de Google de la duena
  // (para saber que productos son mas deseados). No recoge datos personales.
  var FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSfiGgqpb_AOzkRp9XkCM3JWIsWUVlbv2D0Fl1JfNIkarVL11g/formResponse';
  var FORM_CAMPO = 'entry.119127777';
  function registrarFavorito(titulo) {
    if (!titulo) return;
    try {
      var datos = new FormData();
      datos.append(FORM_CAMPO, titulo);
      fetch(FORM_URL, { method: 'POST', mode: 'no-cors', body: datos });
    } catch (e) {}
  }

  function leer() {
    try {
      var v = JSON.parse(localStorage.getItem(CLAVE));
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function guardar(lista) {
    try { localStorage.setItem(CLAVE, JSON.stringify(lista)); } catch (e) {}
  }
  function esFavorito(handle) { return leer().indexOf(handle) !== -1; }

  function alternar(handle) {
    var lista = leer();
    var i = lista.indexOf(handle);
    if (i === -1) lista.push(handle); else lista.splice(i, 1);
    guardar(lista);
    pintarTodos();
    actualizarContador();
    return lista.indexOf(handle) !== -1;
  }

  function pintarBoton(btn) {
    var handle = btn.getAttribute('data-ex-fav');
    if (!handle) return;
    var activo = esFavorito(handle);
    btn.classList.toggle('is-fav', activo);
    btn.setAttribute('aria-pressed', activo ? 'true' : 'false');
    btn.setAttribute('aria-label', activo ? 'Quitar de favoritos' : 'Guardar en favoritos');
    var t = btn.querySelector('[data-ex-fav-texto]');
    if (t) t.textContent = activo ? 'Guardado en favoritos' : 'Guardar en favoritos';
  }
  function pintarTodos() {
    document.querySelectorAll('[data-ex-fav]').forEach(pintarBoton);
  }

  function actualizarContador() {
    var n = leer().length;
    document.querySelectorAll('[data-ex-fav-contador]').forEach(function (el) {
      el.textContent = n > 0 ? n : '';
      el.hidden = n === 0;
    });
  }

  var delegado = false;
  function conectar() {
    // Delegacion en FASE DE CAPTURA a nivel de documento: se ejecuta ANTES de que
    // el enlace de la tarjeta navegue (en las tarjetas de Dawn hay un enlace
    // invisible que cubre toda la tarjeta y se robaba el toque del corazon).
    if (!delegado) {
      delegado = true;
      var ultimoToque = 0;
      function accionFav(btn) {
        var ahoraEsFav = alternar(btn.getAttribute('data-ex-fav'));
        if (ahoraEsFav) {
          registrarFavorito(btn.getAttribute('data-ex-fav-titulo') || btn.getAttribute('data-ex-fav'));
        }
      }
      // Si el dedo se DESLIZA (la clienta esta bajando la pagina) NO se debe guardar
      // el favorito aunque el dedo termine encima de un corazon.
      var inicioX = 0, inicioY = 0, huboDesliz = false;
      document.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches[0]) return;
        inicioX = e.touches[0].clientX;
        inicioY = e.touches[0].clientY;
        huboDesliz = false;
      }, { capture: true, passive: true });
      document.addEventListener('touchmove', function (e) {
        if (huboDesliz || !e.touches || !e.touches[0]) return;
        if (Math.abs(e.touches[0].clientX - inicioX) > 12 ||
            Math.abs(e.touches[0].clientY - inicioY) > 12) huboDesliz = true;
      }, { capture: true, passive: true });
      // En el telefono usamos touchend (hace la accion Y evita que el enlace navegue).
      document.addEventListener('touchend', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-ex-fav]') : null;
        if (!btn) return;
        if (huboDesliz) return; // fue un desliz, no un toque: no tocar nada
        e.preventDefault();
        e.stopPropagation();
        ultimoToque = Date.now();
        accionFav(btn);
      }, { capture: true, passive: false });
      // En escritorio (o si el touch no dispara) usamos click.
      document.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-ex-fav]') : null;
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        if (Date.now() - ultimoToque < 700) return; // ya lo hizo el touchend
        accionFav(btn);
      }, true);
    }
    pintarTodos();
    actualizarContador();
  }

  // ---- Pagina de favoritos ----
  function pintarPagina() {
    var cont = document.querySelector('[data-ex-fav-lista]');
    if (!cont) return;
    var datosEl = document.querySelector('[data-ex-fav-datos]');
    if (!datosEl) return;
    var todos;
    try { todos = JSON.parse(datosEl.textContent); } catch (e) { return; }

    var favs = leer();
    var vacio = document.querySelector('[data-ex-fav-vacio]');
    var elegidos = todos.filter(function (p) { return favs.indexOf(p.handle) !== -1; });

    if (!elegidos.length) {
      cont.innerHTML = '';
      if (vacio) vacio.hidden = false;
      return;
    }
    if (vacio) vacio.hidden = true;

    cont.innerHTML = elegidos.map(function (p) {
      var hover = p.hover ? '<img class="ex-cc__img ex-cc__img--modelo" src="' + p.hover + '" alt="" loading="lazy">' : '';
      return '' +
        '<li class="ex-fav__item">' +
          '<a class="ex-cc__card" href="' + p.url + '">' +
            '<div class="ex-cc__media">' +
              '<img class="ex-cc__img ex-cc__img--principal" src="' + p.img + '" alt="" loading="lazy">' + hover +
            '</div>' +
            '<div class="ex-cc__info">' +
              '<p class="ex-cc__nombre">' + p.titulo + '</p>' +
              '<p class="ex-cc__precio">' + p.precio + '</p>' +
            '</div>' +
          '</a>' +
          '<button type="button" class="ex-fav__quitar" data-ex-fav-quitar="' + p.handle + '" aria-label="Quitar de favoritos">&times;</button>' +
        '</li>';
    }).join('');

    cont.querySelectorAll('[data-ex-fav-quitar]').forEach(function (b) {
      b.addEventListener('click', function () {
        alternar(b.getAttribute('data-ex-fav-quitar'));
        pintarPagina();
      });
    });
  }

  function iniciar() { conectar(); pintarPagina(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else { iniciar(); }

  // al recargar una seccion en el editor de Shopify
  document.addEventListener('shopify:section:load', iniciar);

  window.exFavoritos = { leer: leer, alternar: alternar, esFavorito: esFavorito };
})();
